import { render, staticRenderFns } from "./FilterUserProvider.vue?vue&type=template&id=66f934a1&"
import script from "./FilterUserProvider.vue?vue&type=script&lang=js&"
export * from "./FilterUserProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports